// extracted by mini-css-extract-plugin
export var ignore = "_6x-1";
export var mapping = "_6x-0";
export var range = "_6x-4";
export var savings = "_6x-3";
export var settings = "_6x-2";